module.exports = __webpack_public_path__ + "img/1F6E0.6645ca55.svg";